<template>
  <div id="commonPage_dataPackagList" v-show="currThemeObj">
    <div
      class="abs_topArea"
      :style="{
        backgroundImage: `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/${themeHeaderBannerImage}.png')`,
      }"
    >
      <div class="dateArea">
        <div class="datePicker">
          <el-date-picker
            v-model="currDate"
            popper-class="datePicker_datePackagList"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @change="changeDate"
          ></el-date-picker>
        </div>
        <div class="seasonStartEndDate">
          <span class="title" v-text="seasonTitle"></span>
          <span class="title" v-text="startEndDateArr.join(' 至 ')"></span>
        </div>
      </div>
    </div>
    <div class="broadcastList_area" v-show="themeList && themeList.length > 0">
      <div class="broadcastList_themeArea">
        <div class="themeArea_box">
          <div class="themeOperation_area">
            <span class="themeType_changeArea">
              <span
                class="themeType_item"
                v-for="item in themeTypeArr"
                :key="item.id"
                :class="item.act ? 'act' : ''"
                v-text="item.name"
                @click="changeThemeType(item)"
              ></span>
            </span>
            <span class="themeBtn_area">
              <span
                v-for="item in themeBtnArr"
                :key="item.key"
                v-text="item.name"
                @click="openDialog(item.key)"
              ></span>
            </span>
          </div>
          <themeList_output
            :themeList="themeList"
            :currThemeObj="currThemeObj"
            :currThemeType="currThemeType"
          >
            <template v-slot:itemClose="themeItem">
              <span
                class="themeContainItem_close el-icon-close"
                @click="removeSingleTheme(themeItem.item, 'dataPackage')"
              ></span>
            </template>
            <template v-slot:itemBtnAreaLeft="themeItem">
              <span class="themeContainItem_btnArea left">
                <!-- <span
                          class="btnArea_edit"
                          @click="productPicOrVideo(themeItem.item)"
                          v-show="isMediaBroadcastFlag"
                        >
                          合成
                        </span> -->
                <span class="paddingR10">
                  <LOAD_SUCCESS_BTN
                    :datas="
                      themeItem.item.currPreviewType === 'video'
                        ? themeItem.item.videoPreview_loadSuccessBtnObj
                        : themeItem.item.picPreview_loadSuccessBtnObj
                    "
                    @click="productPicOrVideo(themeItem.item)"
                    v-show="isMediaBroadcastFlag"
                  >
                    合成
                  </LOAD_SUCCESS_BTN>
                </span>
                <span
                  class="btnArea_edit"
                  v-show="themeItem.item.needPicture && isMediaFlag"
                  @click="downDataPicTheme(themeItem.item)"
                >
                  下载
                </span>
                <!-- <span
                          class="btnArea_edit"
                          @click="pushMaterialsItem(themeItem.item)"
                          v-show="isMediaBroadcastFlag"
                        >
                          推送
                        </span> -->

                <!-- 方便测试按钮动画状态的组件 -->
                <!-- <LOAD_SUCCESS_BTN
                          :datas="
                            themeItem.item.currPreviewType === 'video'
                              ? themeItem.item.video_loadSuccessBtnObj
                              : themeItem.item.pic_loadSuccessBtnObj
                          "
                          @click="onSubmit(themeItem.item, themeItem.item.currPreviewType)"
                          v-show="isMediaBroadcastFlag"
                        >
                          推送
                        </LOAD_SUCCESS_BTN> -->

                <LOAD_SUCCESS_BTN
                  :datas="
                    themeItem.item.currPreviewType === 'video'
                      ? themeItem.item.video_loadSuccessBtnObj
                      : themeItem.item.pic_loadSuccessBtnObj
                  "
                  @click="pushMaterialsItem(themeItem.item)"
                  v-show="isMediaBroadcastFlag && isShowPushMaterialBtn"
                >
                  推送
                </LOAD_SUCCESS_BTN>
              </span>
            </template>
            <template v-slot:itemBtnAreaRight="themeItem">
              <span class="themeContainItem_btnArea right">
                <span
                  class="btnArea_edit"
                  @click="eidtSingleTheme(themeItem.item)"
                  v-show="!isBroadcastAdmin"
                >
                  文件命名
                </span>
                <span
                  class="btnArea_edit"
                  v-show="isBroadcastAdmin && themeItem.item.needPicture"
                  @click="downDataPicTheme(themeItem.item)"
                >
                  下载图片
                </span>
                <span
                  class="btnArea_edit"
                  v-show="isBroadcastAdmin"
                  @click="downDataSingleTheme(themeItem.item)"
                >
                  下载数据
                </span>
                <span class="btnGroup" v-show="isMediaBroadcastFlag">
                  <span
                    class="btnItem"
                    :class="
                      themeItem.item.currPreviewType === 'pic' ? 'act' : ''
                    "
                    @click="themeChangeType(themeItem.item, 'pic')"
                  >
                    图片
                  </span>
                  <span
                    class="btnItem"
                    :class="
                      themeItem.item.currPreviewType === 'video' ? 'act' : ''
                    "
                    @click="themeChangeType(themeItem.item, 'video')"
                  >
                    视频
                  </span>
                </span>
              </span>
            </template>
          </themeList_output>
          <div class="themeList_page">
            <el-pagination
              popper-class="mixtmt_pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <NOT_DATA
      :className="'relativePtb60'"
      v-show="themeList && themeList.length == 0"
    />

    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <el-dialog
      :title="
        dialogType == 'eidtThemeItemName' ||
        dialogType == 'dataPackage_setOption'
          ? dialogText
          : '提示'
      "
      custom-class="mixtmt_dialog"
      :visible.sync="isDialogFlag"
      width="40vw"
      top="0"
      center
    >
      <template v-if="dialogType === 'dataPackage_setOption'">
        <div :class="dialogType">
          <div
            class="optionGroup"
            v-for="group in optionList"
            :key="group.type"
          >
            <span class="optionGroup_title">
              <span class="title_icon" :class="group.type"></span>
              <span
                class="name"
                v-text="
                  setOptionGruopTitleNameArr[
                    setOptionGruopTitleKeyArr.indexOf(group.type)
                  ]
                "
              ></span>
            </span>
            <span
              class="optionGroup_list"
              v-for="item in group.twos"
              :key="item.typeTwo"
            >
              <span class="optionItem">
                <span
                  class="optionItem_title"
                  v-text="`${item.typeTwoName}：`"
                ></span>
                <el-checkbox-group v-model="item.checkList">
                  <el-checkbox
                    v-for="ceil in item.threes"
                    :key="ceil.typeThree"
                    :label="ceil.typeThreeName"
                  ></el-checkbox>
                </el-checkbox-group>
              </span>
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <span v-show="dialogType != 'eidtThemeItemName'">
          <span class="dialogText" v-text="dialogText"></span>
        </span>
        <span v-show="dialogType == 'eidtThemeItemName'" class="row_input">
          <span class="row_title">标 题</span>
          <el-input
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 2 }"
            placeholder="请输入内容"
            v-model="editThemeTitle"
          ></el-input>
        </span>
      </template>
      <span slot="footer" class="dialog-footer">
        <span @click="cancelDialog">取 消</span>
        <span @click="clickThemeBtnArea(dialogType)" class="ok">确 定</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  https_media_getStartEndDate,
  https_media_getUserThemeDataList,
  https_media_getRefreshStatus,
} from '@api/platfrom_base_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import themeList_output_data_mixin from '@mixins/themeList_output_data'
// import axios from 'axios'
// const { CancelToken, isCanCel } = axios
export default {
  name: 'commonPage_dataPackagList',
  mixins: [cup_base_data_mixin, themeList_output_data_mixin],
  components: {
    NOT_DATA,
    // LOAD_SUCCESS_BTN,
  },
  props: {
    themeHeaderBannerImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      seasonTitle: '',
      currDate: '',
      startEndDateArr: [],
      curValArr: [],
      eventChildren: null,
      isOpenDateMatchFlag: false,
      actMatchItem: null,
      currTab: {
        id: '',
        name: 'CMG媒体云',
        type: 0,
        themeType: 'media',
        act: true,
      },
      isBroadcastAdmin: false,
      currLevelType: null,
      comTabArr_origin: [
        {
          name: '公共播单',
          id: 'all',
          themeType: 'all',
          type: 'all',
          act: true,
        },
      ],
      adminTabArr_origin: null,
      themeTypeArr: [
        {
          name: '网页',
          id: 'web',
          act: false,
        },
        {
          name: '广播级',
          id: 'broadcast',
          act: true,
        },
      ],
      currThemeType: null,
      themeBtnArr: [],
      comThemeBtnArr: [
        {
          name: '刷新',
          key: 'updateMediaData',
        },
        // {
        //   name: '导入主题',
        //   key: 'import',
        // },
        // {
        //   name: '参数配置',
        //   key: 'dataPackage_setOption',
        // },
        // {
        //   name: '素材推送', //全部素材推送暂时先不做
        //   key: 'sendSource',
        // },
        // {
        //   name: '全部删除',
        //   key: 'roomRemove',
        // },
      ],
      adminThemeBtnArr: [],
      mediaThemeParams: null, //某个演播室接口参数对象
      refreshStatusKey: ['finishStatus', 'finishLists'],
      refreshStatus: null,
      refreshTime: 5 * 1000, //刷新定时接口123的间隔时间
      refreshTimerId: null, //存储监听事件id
      userRoleKey_pushMaterial: 'pushMaterial',
      isShowPushMaterialBtn: false, //true为展示【推送】按钮
    }
  },
  created() {
    // this.axiosCancelSource = CancelToken.source()
    this.getUserRoleList()
    if (this.mixtmt_userRoleKeyList.includes(this.userRoleKey_pushMaterial)) {
      // 是否展示【推送】按鈕
      this.isShowPushMaterialBtn = true
    }
    this.themeBtnArr = this.comThemeBtnArr
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  mounted() {
    this.themeTypeArr.forEach((item) => {
      if (item.act) {
        this.currThemeType = item
      }
    })
    // this.getConfigurationParam()
    // this.allMatchList()
    if (this.isSupportVisibilitychange) {
      // 支持监听切换页签事件
      window.addEventListener('visibilitychange', () => {
        this.documentVisibilityChange()
      })
    } else {
      // 不支持，直接开启长期刷新
    }
  },
  beforeDestroy() {
    if (this.isSupportVisibilitychange) {
      window.removeEventListener('visibilitychange', () => {
        this.documentVisibilityChange()
      })
    }
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug('currGroup dataPackagList:', this.currGroup)
      const query = this.$route.query
      const todayObj = new Date()
      const year = todayObj.getFullYear()
      const month =
        Number(todayObj.getMonth() + 1) > 9
          ? Number(todayObj.getMonth() + 1)
          : `0${Number(todayObj.getMonth() + 1)}`
      const date =
        todayObj.getDate() > 9 ? todayObj.getDate() : `0${todayObj.getDate()}`
      this.currDate = `${year}-${month}-${date}`
      await this.getDataPackagDate()

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    documentVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        // 页签隐藏，停止刷新
        this.clearTimeoutEvent()
        console.debug('当前页签隐藏，即打开新页签', new Date().getTime())
      }
      if (document.visibilityState === 'visible') {
        // 页签显示，先刷新一次接口，检查是否需要持续刷新
        console.debug('当前页签显示，即打开当前页签', new Date().getTime())
        this.initRefreshEvent()
      }
    },
    initRefreshEvent() {
      // 初始化启动定时刷新
      this.clearTimeoutEvent()
      this.getIsRefreshStatus()
    },
    setTimeoutRefreshEvent() {
      this.clearTimeoutEvent()
      this.refreshTimerId = setTimeout(() => {
        this.getIsRefreshStatus()
      }, this.refreshTime)
    },
    clearTimeoutEvent() {
      // 取消定时
      if (this.refreshTimerId) {
        clearTimeout(this.refreshTimerId)
      }
    },
    async analysisRefreshStatusHandler(refreshStatus) {
      // 解析刷新状态的
      if (refreshStatus[this.refreshStatusKey[0]] - 0 === 2) {
        // 刷新主题list
        await this.autoLoadThemeList(true)
        this.setTimeoutRefreshEvent()
      } else if (refreshStatus[this.refreshStatusKey[0]] - 0 === 1) {
        // 定时访问接口123
        this.setTimeoutRefreshEvent()
      } else if (refreshStatus[this.refreshStatusKey[0]] - 0 === 3) {
        // 支持页签切换事件的 停止访问接口123
        if (this.isSupportVisibilitychange) {
          // 支持监听切换页签事件
          this.clearTimeoutEvent()
        } else {
          // 不支持，直接开启长期刷新,定时访问接口123
          this.setTimeoutRefreshEvent()
        }
      }
    },
    changeDate() {
      this.autoLoadThemeList()
    },
    async autoLoadThemeList(isRefresh) {
      // 主题更换就要重置数组，因为重新刷新回来的时候数据里面就是最新状态的
      // 合成|推送等功能
      if (
        this.savePreviewPicArr.length > 0 ||
        this.savePreviewVideoArr.length > 0 ||
        this.savePushMaterialsPicArr.length > 0 ||
        this.savePushMaterialsVideoArr > 0
      ) {
        // 取消接口访问
        this.axiosCancelSource.cancel('取消接口访问')
      }
      this.savePreviewPicArr = []
      this.savePreviewVideoArr = []
      this.savePushMaterialsPicArr = []
      this.savePushMaterialsVideoArr = []
      console.debug('重置数组')
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initScroll()
      if (this.scrollAreaDom.scrollTop > 200 && !isRefresh) {
        // 自动刷新不需要返回顶部
        this.goBackTop() //返回顶部
      }

      this.loadMediaThemeList()
    },
    async loadMediaThemeList() {
      // 媒体云
      this.mediaThemeParams = {
        groupId: this.currGroup.groupId,
        competitionId: this.currCid,
        seasonId: this.currSid,
        date: this.currDate,
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      await this.getUserThemeDataList(this.mediaThemeParams)
      if (this.themeList && this.themeList.length > 0) {
        // 初始化页面 || 切换日期的时候
        this.initRefreshEvent()
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async changeThemeType(item) {
      // 媒体云中切换网页|| 广播级模式，只改变视图，不改变数据
      this.themeTypeArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
          this.currThemeType = item
        } else {
          tabItem.act = false
        }
      })
      this.themeList.forEach((themeItem) => {
        // 图片模式测试
        // themeItem.pictures = [
        //   'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        //   'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
        // ]
        themeItem.isMediaBroadcastFlag = this.isMediaBroadcastFlag
      })
    },
    async getIsRefreshStatus() {
      //获取是否刷新状态
      const parmas = {
        groupId: this.currGroup.groupId,
        competitionId: this.currCid,
        seasonId: this.currSid,
        date: this.currDate,
        dataItemTotal: this.total,
        finishList: this.refreshStatus
          ? this.refreshStatus[this.refreshStatusKey[1]]
          : JSON.stringify([]),
      }
      console.debug('parmas:', parmas)
      await https_media_getRefreshStatus(this.axiosBaseUrl, this.$axios, parmas)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const status = this.refreshStatusKey[0]
            const arr = this.refreshStatusKey[1]
            this.refreshStatus = {
              [status]: res.data && res.data[status] ? res.data[status] : 3,
              [arr]: res.data && res.data[arr] ? res.data[arr] : [], //这个值前端不用，但是后端需要，所以有值就直接回传，没值就是JSON.stringify([])之后回传
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              // this.$message({
              //   showClose: true,
              //   message: res.message ? res.message : '服务器异常，请稍后再试',
              //   type: 'warning',
              // })
            }
          }
        })
        .catch((err) => {
          // console.debug(err)
        })
      // 无论接口正常还是报错，接口返回后再处理状态
      this.analysisRefreshStatusHandler(this.refreshStatus)
      console.debug('this.refreshStatus:', this.refreshStatus)
    },
    async getDataPackagDate() {
      //获取数据包装的日期
      let parmas = {
        cid: this.currCid,
        sid: this.currSid,
      }
      await https_media_getStartEndDate(this.axiosBaseUrl, this.$axios, parmas)
        .then(async (response) => {
          const res = response.data
          if (res.status === 0) {
            this.startEndDateArr = [res.data.startDate, res.data.endDate]
            // const mixtmt_platfromV4_currSeason = JSON.parse(
            //   this.$localStorage.getItem('mixtmt_platfromV4_currSeason')
            // )
            // this.seasonTitle =
            //   (mixtmt_platfromV4_currSeason.name
            //     ? `【${mixtmt_platfromV4_currSeason.name}】`
            //     : '') + '起止日期：'
            // this.currDate = res.data.startDate
            this.seasonTitle = '比赛日期：'
            await this.autoLoadThemeList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getUserThemeDataList(query) {
      //获取某日媒体云主题
      await https_media_getUserThemeDataList(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.themeList = res.data
              ? this.allThemeRenderHandler(res.data.list)
              : []
            this.total = res.data.total
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#commonPage_dataPackagList {
  padding-top: 6.94vw;
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 6.94vw;
    color: var(--mixtmt_whiteColor);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .dateArea {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      height: 6.94vw;
    }
    .datePicker {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      height: 6.94vw;
      width: 13.88vw;
    }
    .seasonStartEndDate {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      height: 6.94vw;
      width: calc(100% - 16.66vw);
      span {
        letter-spacing: 0.1vw;
        font-size: 1.38vw;
        color: var(--mixtmt_whiteColor);
      }
    }
  }
  .broadcastList_area {
    width: 100%;
    padding: 2.083vw 0 2.778vw;

    .broadcastList_themeArea {
      /* width: calc(100% - 20.83vw); */
      width: 100%;
      /* padding-left: 1.388vw; */
      .themeArea_box {
        width: 100%;
        /* padding: 1.388vw; */
        /* border: 1px solid var(--mixtmt_greyColor7); */
        border-radius: 0.556vw;
        .themeOperation_area {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.5vw;
          .themeType_changeArea {
            width: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            border: 1px solid var(--mixtmt_btn_tabMeun_actColor);
            border-radius: 1.25vw;
            .themeType_item {
              width: 8.62vw;
              line-height: calc(2.5vw - 2px);
              text-align: center;
              color: var(--mixtmt_btn_tabMeun_actColor);
              font-size: 0.972vw;
              &.act {
                background-color: var(--mixtmt_btn_tabMeun_actColor);
                color: var(--mixtmt_whiteColor);
                &:first-child {
                  border-radius: 1.25vw 0 0 1.25vw;
                }
                &:last-child {
                  border-radius: 0 1.25vw 1.25vw 0;
                }
              }
            }
          }
          .themeBtn_area {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            align-items: center;
            span {
              display: inline-block;
              margin-left: 0.972vw;
              line-height: calc(2.5vw - 2px);
              font-size: 1.11vw;
              padding: 0 0.972vw;
              border: 1px solid var(--mixtmt_greyColor7);
              color: var(--mixtmt_greyColor2);
              border-radius: 2px;
              &:first-child {
                margin-left: 0;
              }
            }
          }
        }
      }
      .themeList_page {
        text-align: right;
      }
    }

    .cardTheme {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      flex-direction: column;
      .themeItem_title {
        margin-bottom: 1.388vw;
        width: 100%;
        height: 2.5vw;
        background-image: var(--mixtmt_themeItem_title_bg0);
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
        color: var(--mixtmt_whiteColor);
        font-size: 0.972vw;
        text-align: center;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
      }
      .card_item {
        width: 60%;
        height: calc(21.54vw - 1.388vw);
        .cardItem_topBg {
          display: block;
          width: 100%;
          height: 0.42vw;
          background-color: var(--mixtmt_mainColor3);
        }
        .cardItem_main {
          position: relative;
          display: block;
          border: 1px solid var(--mixtmt_mainColor3);
          border-top: none;
          height: auto;
          color: var(--mixtmt_greyColor3);
          .cardItem_main_title {
            display: block;
            width: 100%;
            height: 4.166vw;
            line-height: 4.166vw;
            font-size: 1.25vw;
            text-align: center;
          }
          .theme_publishBtn {
            position: absolute;
            top: 1vw;
            right: 0;
            z-index: 10;
            width: 2.778vw;
            text-align: center;
            font-size: 1.11vw;
            line-height: 2.166vw;
            color: var(--mixtmt_blackColor);
          }
          .cardItem_row {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 2.083vw;
            width: 100%;
            height: calc(3.33vw + 1px);
            border-top: 1px solid var(--mixtmt_greyColor7);
            .cardItem_row_image {
              width: 2.083vw;
              height: 2.083vw;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            .cardItem_row_text {
              width: calc(100% - 2.083vw);
              padding-left: 0.833vw;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 0.972vw;
            }
            &.overviewTeamData,
            &.overviewPlayerData {
              padding: 0 0.694vw;
              .rankNo {
                width: 1.388vw;
                font-size: 0.972vw;
                text-align: center;
              }
              .cardItem_row_name {
                width: calc(100% - 1.388vw - 2.083vw - 3.472vw);
                padding-left: 0.833vw;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 0.972vw;
              }
              .cardItem_row_val {
                width: 3.472vw;
                text-align: right;
                padding-left: 0.833vw;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 0.972vw;
              }
            }
            &.overviewTeamData {
              .cardItem_row_name {
                width: calc(100% - 1.388vw - 2.083vw - 7.472vw);
              }
              .cardItem_row_val {
                width: 7.472vw;
              }
            }
          }
        }
      }
    }
  }
  /* .changeUserBtn {
      position: fixed;
      right: 1.388vw;
      bottom: 1.388vw;
      z-index: 1100;
      width: 2.778vw;
      height: 2.778vw;
      span {
        display: block;
        font-size: 1.338vw;
        line-height: 2.778vw;
        text-align: center;
        background-color: var(--mixtmt_whiteColor);
        border: 1px solid var(--mixtmt_greyColor7);
        color: var(--mixtmt_greyColor6);
        border-radius: 50%;
      }
      &.act {
        span {
          background-color: var(--mixtmt_subColor1_1);
          border: 1px solid var(--mixtmt_subColor1_1);
          color: var(--mixtmt_whiteColor);
        }
      }
    } */
}
.mixtmt_pc #commonPage_dataPackagList,
.mixtmt_ipad #commonPage_dataPackagList {
  padding: 6.94vw 0 0;
}
.mixtmt_pc #commonPage_dataPackagList {
  .broadcastList_area {
    .broadcastList_themeArea {
      .themeArea_box {
        .themeOperation_area {
          .themeType_changeArea {
            .themeType_item {
              cursor: pointer;
              &:hover {
                background-color: var(--mixtmt_btn_tabMeun_actColor);
                color: var(--mixtmt_whiteColor);
                &:first-child {
                  border-radius: 1.25vw 0 0 1.25vw;
                }
                &:last-child {
                  border-radius: 0 1.25vw 1.25vw 0;
                }
              }
            }
          }
          .themeBtn_area {
            span {
              cursor: pointer;
              &:hover {
                background-color: var(--mixtmt_btn_tabMeun_actColor);
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
    }
  }
  .changeUserBtn {
    &:hover {
      cursor: pointer;
      span {
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_subColor1_1);
      }
    }
    &.act:hover {
      span {
        color: var(--mixtmt_subColor1_1);
        background-color: var(--mixtmt_whiteColor);
      }
    }
  }
}
</style>
<style lang="scss">
#commonPage_dataPackagList {
  .abs_topArea {
    .datePicker {
      .el-date-editor.el-input {
        width: 100%;
      }
      .el-date-editor .el-input__inner {
        width: 100%;
        height: 3.47vw;
        font-size: 1.388vw;
        text-align: center;
        font-weight: bold;
        /* border: 1px solid var(--mixtmt_whiteColor);
        color: var(--mixtmt_whiteColor);
        background: transparent; */
        &::-webkit-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-ms-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
        &::selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
      }
      .el-input--prefix .el-input__inner {
        padding-left: 3vw;
      }
      .el-input--suffix .el-input__inner {
        padding-right: 3vw;
      }
      .el-range-editor.el-input__inner {
        padding: 0.208vw 0.694vw;
      }
      .el-date-editor .el-range__icon,
      .el-date-editor .el-range__close-icon {
        width: 2.083vw;
        height: auto;
        line-height: 1;
        font-size: 1.66vw;
        margin-left: 0;
        color: var(--mixtmt_whiteColor);
        line-height: 3.054vw;
      }
      .el-date-editor .el-range-input {
        width: calc(46% - 2.083vw);
        font-size: 1.388vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
        background: transparent;
        &::-webkit-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &:-ms-input-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &:-moz-placeholder {
          color: var(--mixtmt_greyColor11);
          font-weight: lighter;
        }
        &::-moz-selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
        &::selection {
          color: var(--mixtmt_greyColor11);
          background: rgba(0, 0, 0, 0.25);
          font-weight: lighter;
        }
      }
      .el-date-editor .el-range-separator {
        padding: 0;
        height: auto;
        line-height: 1;
        font-size: 1.388vw;
        width: 8%;
        color: var(--mixtmt_whiteColor);
      }

      .el-input__icon {
        color: var(--mixtmt_whiteColor);
        line-height: 3.054vw;
        font-size: 1.66vw;
      }
    }
  }
  .matchArea_date {
    .el-carousel__container {
      height: calc(4.16vw - 2px);
    }
    .el-carousel__arrow {
      cursor: default;
      height: 2.083vw;
      width: 2.083vw;
      background-color: transparent;
      i {
        cursor: default;
        color: var(--mixtmt_greyColor3);
      }
    }
  }
  .themeList_page {
    .el-pager li {
      padding: 0 0.53333vw;
      background: var(--mixtmt_whiteColor);
      font-size: 0.972vw;
      min-width: 2.22vw;
      height: 2.22vw;
      line-height: 2.22vw;
      box-sizing: border-box;
    }
    .el-pagination button,
    .el-pagination span:not([class*='suffix']) {
      display: inline-block;
      font-size: 0.972vw;
      min-width: 2.22vw;
      height: 2.22vw;
      line-height: 2.22vw;
      vertical-align: top;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .el-pagination .el-select .el-input {
      width: 6.944vw;
      margin: 0 0.66667vw;
    }
    .el-pagination .el-select .el-input .el-input__inner {
      padding-right: 1.11vw;
      border-radius: 0.4vw;
      height: 2.22vw;
      line-height: 2.22vw;
      font-size: 0.972vw;
    }
    .el-pagination__editor.el-input .el-input__inner {
      height: 2.22vw;
      font-size: 0.972vw;
      line-height: 2.22vw;
    }
    .el-pagination__editor.el-input {
      width: 4.16vw;
    }
    .el-pagination__jump {
      margin-left: 0.972vw;
    }
    .el-pagination__sizes {
      margin: 0;
    }
    .el-pager li.active,
    .el-pager li:hover,
    .el-pagination button:hover,
    .el-pagination__sizes .el-input .el-input__inner:hover {
      color: var(--mixtmt_subColor1_1);
    }
    .el-pagination__sizes .el-input .el-input__inner:hover,
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: var(--mixtmt_subColor1_1);
    }
  }
  .el-dialog__wrapper {
    width: 100%;
    z-index: 1610 !important;
    .mixtmt_dialog {
      border-radius: 1.042vw;
      transform: translateY(-50%);
      top: 50%;
      .el-dialog__header {
        padding: 2.083vw 2.778vw 1.043vw 2.778vw;
        .el-dialog__title {
          line-height: 1.8vw;
          font-size: 1.25vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
      }
      .el-dialog__body {
        padding: 1.043vw 2.778vw;
        .dialogText {
          line-height: 1.388vw;
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor2);
        }
        .row_input {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          .row_title {
            padding-right: 0.694vw;
            width: 6.94vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor3);
            text-align: center;
          }
          .el-input {
            color: var(--mixtmt_greyColor2);
            input {
              height: 2.778vw;
              line-height: calc(2.778vw - 2px);
              font-size: 0.972vw;
              background-color: var(--mixtmt_greyColor8);
              padding: 0 4vw 0 1.042vw;
            }
            .el-input__count .el-input__count-inner {
              background-color: var(--mixtmt_greyColor8);
            }
          }
        }
        .setOption {
          max-height: 20.83vw;
          overflow-y: auto;
          .optionGroup {
            width: 100%;
            height: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            .optionGroup_title {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;

              color: var(--mixtmt_greyColor3);
              .title_icon {
                width: 1.388vw;
                height: 1.388vw;
                overflow: hidden;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: center;
                background-color: var(--mixtmt_greyColor8);
                /* &.video {
                      background-image: var();
                    } */
              }
              .name {
                padding-left: 0.694vw;
                font-size: 1.11vw;
                line-height: 1.388vw;
              }
            }
            .optionGroup_list {
              padding-top: 2.083vw;
              height: auto;
              .optionItem {
                display: flex;
                display: -webkit-flex;
                justify-content: flex-start;
                align-items: center;
                padding: 0 0.694vw 0 2.083vw;
                .optionItem_title {
                  width: 8.333vw;
                  font-size: 1.11vw;
                }
                .el-checkbox {
                  font-size: 1.11vw;
                  margin-right: 2.083vw;
                }
              }
              &:last-child {
                .optionItem {
                  padding-bottom: 2.788vw;
                }
              }
            }
          }
        }
      }
      .el-dialog__footer {
        padding: 2.083vw 2.778vw;
        .dialog-footer {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          span {
            width: 10.416vw;
            height: 2.778vw;
            background-color: var(--mixtmt_whiteColor);
            line-height: calc(2.778vw - 2px);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
            border-radius: 0.347vw;
            &.ok {
              background-color: var(--mixtmt_mainColor3);
              color: var(--mixtmt_whiteColor);
            }
            &:nth-child(2) {
              margin-left: 1.388vw;
            }
          }
        }
      }
    }
  }
  .el-drawer__wrapper {
    z-index: 1650 !important;
  }
  .mixtmt_broadcast_derawer {
    header {
      display: none;
    }
  }
}

.mixtmt_pc #commonPage_dataPackagList {
  .matchArea_date {
    .el-carousel__arrow {
      cursor: pointer;
      i {
        cursor: pointer;
      }
      &:hover {
        i {
          opacity: 0.6;
        }
      }
    }
  }
  .el-dialog__wrapper {
    z-index: 1610 !important;
    .mixtmt_dialog {
      .el-dialog__headerbtn:focus .el-dialog__close,
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: var(--mixtmt_mainColor);
      }
      .el-dialog__footer {
        .dialog-footer {
          span {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
              border-color: var(--mixtmt_mainColor6);
            }
          }
        }
      }
    }
  }
  .dateMatch_row {
    .el_icon_btn,
    .matchText {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_subColor1_1);
      }
    }
    .matchText {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.mixtmt_pagination {
  .el-select-dropdown__item {
    font-size: 0.972vw;
    padding: 0 1.388vw;
    height: 2.778vw;
    line-height: 2.778vw;
    &.selected {
      color: var(--mixtmt_mainColor);
    }
    &.hover {
      background-color: var(--mixtmt_greyColor8);
    }
  }
}
</style>
